import { useCallback, useEffect, useState } from "react";
import { useContext } from "react";
import ReactSelect from "react-select";
import { Helmet } from "react-helmet-async";
import UserContext from "../context/user";
import useBreakpoint from "../hooks/useBreakpoint";
import logo from "../images/EssilorLuxotticaLogo.svg";
import Icon from "./icon";
import LogoutModal from "./logout-modal";
import Translate from "./translate";

const Header = ({
  app = "SURVEY",
  selectedLanguage,
  setSelectedLanguage,
  languages,
  labels,
  appTitle,
}) => {
  const { logout, userProfile } = useContext(UserContext);
  const onChange = (selectedOption) => setSelectedLanguage(selectedOption);
  const isMobile = useBreakpoint(575);
  const [logoutModal, setLogoutModal] = useState();

  useEffect(() => {
    if (userProfile?.language) {
      setSelectedLanguage(
        languages.find((lang) => lang.value === userProfile.language) ||
          languages.find((lang) => !!lang)
      );
    }
  }, [userProfile, languages, setSelectedLanguage]);

  const handleLogout = useCallback(() => {
    if (isMobile) {
      setLogoutModal(true);
    } else {
      logout();
    }
  }, [isMobile, logout]);

  return (
    <header className={`header header--${app.toLowerCase()}`}>
      <Helmet
        htmlAttributes={{
          lang: selectedLanguage?.value,
        }}
      ></Helmet>
      <div className="wrapper">
        <div className="header__content">
          <div className="header__box">
            {app !== "SURVEY" && (
              <div className="header__title">
                {appTitle ? (
                  <Translate text={appTitle} />
                ) : (
                  labels?.[`WELFARE_TITLE_${app}`] || "WELFARE"
                )}
              </div>
            )}
            <img className="header__logo" src={logo} alt="EssilorLuxottica" />
          </div>
          <div className="header__info">
            {languages?.length > 1 && (
              <div className="header__lang">
                <ReactSelect
                  options={languages}
                  className="header__select"
                  classNamePrefix="app-select"
                  aria-label="Language select"
                  value={selectedLanguage}
                  onChange={onChange}
                  isSearchable={false}
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator: () => <Icon name="angle-down" />,
                  }}
                />
              </div>
            )}
            <div className="header__user">
              <div>
                <span>{labels?.HELLO}</span>{" "}
                <span translate="no">
                  {userProfile?.firstName} {userProfile?.lastName}
                </span>
              </div>
              <button onClick={handleLogout} aria-label="Logout">
                <Icon name="share" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <LogoutModal
        show={logoutModal}
        closeModal={() => setLogoutModal(false)}
        labels={labels}
        key={!!logoutModal}
      />
    </header>
  );
};

export default Header;
